import Loading from "../components/Loading";
import useAuth from "../hooks/useAuth";
import AnimalDashboard from "../pages/animals/AnimalDashboard";
import AdminDashboard from "../pages/admin/AdminDashboard";
import SuperAdminDashboard from "../pages/dashboard/SuperAdminDashboard";
import { Navigate } from "react-router-dom";
import {
  needsCreateFarmOnboarding,
  needsTenantWelcomeFlow,
} from "../auth/postLoginRedirect";

/**
 * Root app home: onboarding when needed; otherwise role-based dashboard (Phase 1).
 */
export default function PostAuthHome() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <Loading />;
  }

  if (needsCreateFarmOnboarding(user)) {
    return <Navigate to="/create-farm" replace />;
  }

  if (needsTenantWelcomeFlow(user)) {
    return <Navigate to="/farm-setup" replace />;
  }

  const roles = user?.roles || [];
  if (roles.includes("super_admin")) {
    return <SuperAdminDashboard />;
  }

  const isTenantAdmin = roles.includes("TenantAdmin");
  const canManageUsers = user?.permissions?.includes("manage_users");
  if (isTenantAdmin || canManageUsers) {
    return <AdminDashboard />;
  }

  return <AnimalDashboard />;
}
